import { render, staticRenderFns } from "./ColorTagPicker.vue?vue&type=template&id=1eb68444&scoped=true&"
import script from "./ColorTagPicker.vue?vue&type=script&lang=js&"
export * from "./ColorTagPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorTagPicker.vue?vue&type=style&index=0&id=1eb68444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb68444",
  null
  
)

export default component.exports